import Zoom from 'react-medium-image-zoom';
import { config } from 'config';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { parseLicenseAttentionType } from 'core/Statistics';
import { patientActions } from 'core/Patient';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    Card,
    ExpandButton,
    FormGroup,
    IconButton,
    Loader,
    SelectSearch,
    TagList
} from 'mol-ui';
import {
    Col,
    Row
} from 'reactstrap';
import {
    Container,
    FileNameContainer,
    PDFContainer,
    PDFIcon,
    StyledCol,
    StyledLink
} from './styled';
import {
    MessagesModal,
    PDFFullScreenViewer
} from 'views/components';
import React, { useEffect, useState } from 'react';
import {
    minutesFormat,
    parseGender,
    parseLicenseNextStep,
    parsePaymentMethod
} from 'shared/utils';
import {
    useDispatch,
    usePrinter,
    useSelector,
    useToggle
} from 'hooks';
import {
    useHistory,
    useLocation
} from 'react-router-dom';
const { diagnosisDetailedInformation } = config;
const pdf = require('assets/images/pdf.png');

const PatientRecap = () => {

    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const { push } = useHistory();
    const { t } = useTranslation();

    const [printRef, handlePrint] = usePrinter();

    const [selectedFile, setSelectedFile] = useState(-1);
    const [showModal, toggleShowModal] = useToggle(false);

    const urlId = Number(pathname.split('/')[3]);
    const type = pathname.split('/')[2] === t('registro') ? 'call' : 'evolution';

    const {
        recap,
        recapLoading: loading
    } = useSelector('patient');
    
    useEffect(() => {
        const data = {
            id: urlId,
            type
        };
        dispatch(patientActions.getPatientRecap(data));
    }, [urlId]);

    const {
        age,
        call_doctors,
        chat,
        consultation_reasons,
        date,
        diagnoses,
        duration,
        email,
        full_name,
        gender,
        guests,
        health_insurance,
        history = [],
        identification,
        images,
        license,
        medical_coverage,
        method,
        note,
        patient_address,
        patient_building_number,
        patient_city,
        patient_door_number,
        patient_floor,
        patient_province,
        pin,
        plan,
        presumptive_diagnosis,
        professional,
        recommendations,
        record_archives,
        specialty,
        symptoms
    } = recap;

    const fullAddress = patient_address ?
        `${ patient_address ?? '' } ${ patient_building_number ?? '' } ${ patient_floor ?? '' } ${ patient_door_number ?? '' } ${ patient_city ?? '' } ${ patient_province ?? '' } `
        : null;
    const callStatus = !isEmpty(call_doctors) ? call_doctors[0].status.statusLabel : null;
    const joinedGuests = (guests ?? []).filter(({ joined }) => !!joined);

    const patientData = [{
        title: t('Nombre'),
        value: full_name
    }, {
        title: t('DNI'),
        value: identification
    }, {
        title: t('Sexo'),
        value: parseGender(gender)
    }, {
        title: t('Edad'),
        value: age
    }, {
        title: t('Email'),
        value: email
    }, {
        title: t('Ubicación'),
        value: fullAddress
    }, {
        hide: !plan,
        title: t('Plan'),
        value: plan
    }, {
        hide: !health_insurance,
        title: t('Afiliado'),
        value: health_insurance
    }, {
        hide: !method,
        title: t('Validación'),
        value: parsePaymentMethod(method, medical_coverage)
    }];

    const recapData = [{
        title: 'Fecha y hora',
        value: `${ moment(date).format('DD/MM/YYYY HH:mm') }`
    }, {
        hide: !type === 'call',
        title: t('Duración'),
        value: duration
    }, {
        hide: !type === 'call',
        title: t('Estado'),
        value: callStatus
    }, {
        hide: !pin,
        title: t('PIN'),
        value: pin
    }, {
        hide: !specialty,
        title: t('Especialidad'),
        value: specialty
    }, {
        hide: !professional,
        title: t('Profesional'),
        value: professional
    }];

    const handleDiagnosisChange = value => {
        push(`${ t('/pacientes/evolucion') }/${ value }`);
    };

    if (loading) {
        return <Loader active />;
    }

    return (
        <Container ref={ printRef }>
            <Card title={ t('Datos del paciente') }>
                <Row>
                    {
                        patientData.map(({ hide, title, value }, index) => {
                            if (hide) return null;
                            return (
                                <Col key={ index } lg="3" md="4" xs="6">
                                    <FormGroup label={ title } margin="0px 0px 20px 0px">
                                        { !!value ? value : '-'}
                                    </FormGroup>
                                </Col>
                            );
                        })
                    }
                </Row>
            </Card>
            {
                history.length > 1 &&
                <Row>
                    <StyledCol>
                        <Card title={ t('Historial de ediciones') }>
                            <SelectSearch
                                margin="10px 0px 0px 0px"
                                options={ history }
                                value={ urlId }
                                width="100%"
                                onChange={ handleDiagnosisChange }
                            />
                        </Card>
                    </StyledCol>
                </Row>
            }
            <Row>
                <StyledCol>
                    <Card title={ type === 'call' ? t('Datos de la llamada') : t('Datos de la evolución') }>
                        <Row>
                            {
                                recapData.map(({ hide, title, value }, index) => {
                                    if (hide) return null;
                                    return (
                                        <Col key={ index } lg="3" md="4" xs="6">
                                            <FormGroup label={ title } margin="0px 0px 20px 0px">
                                                { !!value ? value : '-'}
                                            </FormGroup>
                                        </Col>
                                    );
                                })
                            }
                        </Row>
                    </Card>
                </StyledCol>
                {
                    type === 'call' && diagnosisDetailedInformation &&
                    <StyledCol lg="4" md="12">
                        <Card noPrint title={ t('Acciones') }>
                            <IconButton
                                icon="question_answer"
                                label={ t('Ver historial de chat') }
                                onClick={ toggleShowModal }
                            />
                            {
                                !isEmpty(record_archives) && record_archives.filter(({ duration }) => !duration || duration > 2).map(({
                                    archive_id,
                                    duration,
                                    url
                                }) =>
                                    <Row key={ archive_id }>
                                        <StyledLink href={ `${ url }` } target="Multimedia">
                                            { t('Reproducir multimedia') } { !!duration ? `(${ minutesFormat(duration) })` : '' }
                                        </StyledLink>
                                    </Row>
                                )
                            }
                        </Card>
                    </StyledCol>
                }
            </Row>
            {
                diagnosisDetailedInformation &&
                <Card title={ t('Ficha') }>
                    <Row>
                        <Col>
                            {
                                type === 'call' && symptoms &&
                                <FormGroup label={ t('Síntomas del paciente') } margin="0px 0px 10px 0px">
                                    <TagList
                                        readOnly
                                        items={ symptoms.split(',').map(item => ({ label: item })) }
                                    />
                                </FormGroup>
                            }
                            {
                                !isEmpty(consultation_reasons) &&
                                <FormGroup label={ t('Motivo de consulta') } margin="0px 0px 10px 0px">
                                    { consultation_reasons.map(({ diagnoses_term }) => diagnoses_term).join(', ') }
                                </FormGroup>
                            }
                            <FormGroup label={ t('Diagnóstico') } margin="0px 0px 10px 0px">
                                { diagnoses ? diagnoses.map(({ diagnoses_term }) => diagnoses_term).join(', ') : '-' }
                            </FormGroup>
                            {
                                !!presumptive_diagnosis &&
                                <FormGroup label={ t('Diagnóstico presuntivo') } margin="0px 0px 10px 0px">
                                    { presumptive_diagnosis }
                                </FormGroup>
                            }
                            <FormGroup label={ t('Evolución médica') } margin="0px 0px 10px 0px">
                                { note ? note : '-' }
                            </FormGroup>
                            {
                                recommendations &&
                                <FormGroup label={ t('Recomendaciones médicas') } margin="0px 0px 10px 0px">
                                    { recommendations }
                                </FormGroup>
                            }
                            {
                                !isEmpty(license) &&
                                <>
                                    {
                                        !!license.attention_type &&
                                        <FormGroup label={ t('Atención') } margin="0px 0px 10px 0px">
                                            { parseLicenseAttentionType(license.attention_type) }
                                        </FormGroup>
                                    }
                                    {
                                        !!license?.reason?.label &&
                                        <FormGroup label={ t('Licencia') } margin="0px 0px 10px 0px">
                                            { license.reason.label }
                                        </FormGroup>
                                    }
                                    {
                                        license?.days !== null && license?.days !== undefined &&
                                        <FormGroup label={ t('Días de licencia') } margin="0px 0px 10px 0px">
                                            { license.days }
                                        </FormGroup>
                                    }
                                    {
                                        (!!license?.from_date || !!license?.to_date) &&
                                        <FormGroup label={ t('Rango') } margin="0px 0px 10px 0px">
                                            { license.from_date ? moment(license.from_date).format('DD/MM/YYYY') : '' } a { license.to_date ? moment(license.to_date).format('DD/MM/YYYY') : '' }
                                        </FormGroup>
                                    }
                                    {
                                        !!license?.next_step &&
                                        <FormGroup label={ t('Siguiente paso') } margin="0px 0px 10px 0px">
                                            { parseLicenseNextStep(license.next_step) }{ license?.next_step_date ? ` - ${ moment(license.next_step_date).format('DD/MM/YYYY') }` : '' }
                                        </FormGroup>
                                    }
                                    {
                                        !!license?.external_request &&
                                            <>
                                                <FormGroup label={ t('Licencia solicitada externamente') } margin="0px 0px 10px 0px">
                                                    { license.requested_from_date ? moment(license.requested_from_date).format('DD/MM/YYYY') : '' } a { license.requested_to_date ? moment(license.requested_to_date).format('DD/MM/YYYY') : '' }
                                                </FormGroup>
                                                <FormGroup label={ t('Días solicitados externamente') } margin="0px 0px 10px 0px">
                                                    { license.requested_days ?? 0 }
                                                </FormGroup>
                                            </>
                                    }
                                </>
                            }
                            {
                                !isEmpty(joinedGuests) &&
                                <FormGroup label={ t('Participantes adicionales') } margin="0px 0px 10px 0px">
                                    <TagList
                                        readOnly
                                        direction="column"
                                        items={ joinedGuests.map(({
                                            dummy,
                                            first_name,
                                            last_name,
                                            type
                                        }) => ({
                                            label: `${ (type === 'doctor' ? t('Profesional') : t('Paciente')) } - ${ (!!dummy ? ('Invitado') : `${ last_name }, ${ first_name }`) }`
                                        })) }
                                    />
                                </FormGroup>
                            }
                        </Col>
                        {
                            type === 'call' && !isEmpty(images) &&
                            <Col>
                                {
                                    images.map(({ file_name, image, note }, index) =>
                                        <Row key={ index }>
                                            <Col sm="4" xs="12">
                                                {
                                                    file_name.endsWith('.pdf')
                                                        ? <PDFContainer>
                                                            <PDFIcon src={ pdf.default } onClick={ () => setSelectedFile(index) } />
                                                            {
                                                                selectedFile === index &&
                                                                <PDFFullScreenViewer
                                                                    file={ image }
                                                                    toggle={ () => setSelectedFile(-1) }
                                                                />
                                                            }
                                                            <FileNameContainer>
                                                                { file_name }
                                                            </FileNameContainer>
                                                        </PDFContainer>
                                                        : <Zoom>
                                                            <img
                                                                alt={ file_name }
                                                                src={ image }
                                                                style={{ display: 'block', width: '100%' }}
                                                            />
                                                        </Zoom>
                                                }
                                            </Col>
                                            <Col sm="8" xs="12">
                                                { note }
                                            </Col>
                                        </Row>
                                    )
                                }
                            </Col>
                        }
                    </Row>
                </Card>
            }
            <MessagesModal
                active={ showModal }
                messages={ chat }
                onToggle={ toggleShowModal }
            />
            <ButtonFooter margin="20px 0px 0px 0px">
                <ExpandButton
                    caption={ t('Imprimir') }
                    size={ 120 }
                    onClick={ handlePrint }
                />
                <ExpandButton
                    caption={ t('Volver') }
                    size={ 120 }
                    onClick={ () => push(t('/dashboard')) }
                />
            </ButtonFooter>
        </Container>
    );
};

export default PatientRecap;
